import type { ErrorEvent } from '@sentry/core';
import { isEnvironmentalError } from './environmentalErrors';

export function beforeErrorSampling(event: ErrorEvent): boolean {
  // Returning false stops timeout / network errors from triggering a session replay.
  return !isEnvironmentalError(event);
}
